import React, { useState, useEffect } from "react";
import styles from "./Accordion.module.scss";
import AccordionItem from "../../components/AccordionItem/AccordionItem";
import Envelope from "../../public/assets/icons/envelope.svg";
import Phone from "../../public/assets/icons/phone.svg";
import Whatsapp from "../../public/assets/icons/whatsapp.svg";

const Accordion = ({ title, fullscreen, items, bookTitle, links }) => {
  const [accordionItems, setAccordionItems] = useState();

  const getId = (str) => {
    return str.toLowerCase().replace(" ", "-")
  }

  useEffect(() => {
    if (items && items.length > 0) {
      if (fullscreen) {
        setAccordionItems(
          items.map((d) => (
            <AccordionItem
              parentId={getId(d.title)}
              key={d.title}
              title={d.title}
              subtitle={d.subtitle}
              text={d.text}
              fullscreen
            />
          ))
        );
      } else {
        setAccordionItems(
          items.map((d) => {
            return (
              <div key={d.title} id={getId(d.title)}>
                <AccordionItem parentId={getId(d.title)} key={d.title} title={d.title} text={d.html} links={d.links} />
              </div>
            )
          }
          )
        );
      }
    }
  }, [items]);

  return (
    <div className={styles.Accordion}>
      <div className={fullscreen ? styles.goldText : styles.darkText}>{title}</div>
      <div className={styles.accordionItems}>{accordionItems}</div>
      <div className={styles.flexBottom} style={{ display: fullscreen ? "flex" : "none" }}>
        <div className={styles.goldText}>{bookTitle}</div>
        <div className={styles.icons}>
          {links && links.map(d => {
            if (d.type === "email") {
              return (
                <a key={d.type} href={d.url}><Envelope /></a>
              )
            }
            else if (d.type === "phone") {
              return (
                <a key={d.type} href={d.url}><Phone /></a>
              )
            }
            else if (d.type === "phone") {
              return (
                <a key={d.type} href={d.url}><Whatsapp /></a>
              )
            }
          })}
        </div>
      </div>
    </div>
  );
};

export default Accordion;
